import { Component } from 'react'
import { withRouter } from 'react-router'
import MoveTo from 'moveto'

class ScrollToTop extends Component {
  moveTo = new MoveTo({
    tolerance: 0,
    duration: 200,
    easing: 'easeOutQuart'
  })

  componentDidMount () {
    // moveTo Top
    this.moveTo.move(document.body)
  }

  componentDidUpdate (prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0)
    }
  }

  render () {
    return this.props.children || null
  }
}

export default withRouter(ScrollToTop)



// WEBPACK FOOTER //
// ./src/components/ScrollToTop.js